//Track
<template>
  <v-scale-transition>
    <wide-panel
      :title="title"
    >
      <v-toolbar flat>
        <v-menu
          v-model="monthMenu"
          :close-on-content-click="false"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="month"
              prepend-icon="mdi-calendar-outline"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="month"
            min="2020-11"
            :max="thisMonth"
            type="month"
            no-title
            @input="monthMenu = false"
          />
        </v-menu>
        <v-spacer />
        <v-autocomplete
          v-if="xforceAdmin"
          v-model="location"
          :items="locations"
          label="Select or type location"
          item-text="location"
          item-value="code"
          prepend-icon="mdi-city"
          return-object
        >
          <template #item="data">
            <v-list-tile-content>
              <v-list-tile-title>{{ data.item.location }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ data.item.leadDealer }}, {{ data.item.pic }}, {{ data.item.contact }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </v-autocomplete>
      </v-toolbar>
      <v-subheader>Activations</v-subheader>
      <v-sheet>
        <v-btn
          absolute
          dark
          fab
          small
          top
          right
          color="light-green"
          @click="exportTracking(activations)"
        >
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-sheet>
      <v-data-table
        :headers="activationHeaders"
        :items="activations"
        :expand="expand"
        :loading="loading"
        item-key="day"
        class="elevation-1"
      >
        <template #items="props">
          <tr
            :active="props.selected"
            @click="props.expanded = !props.expanded"
          >
            <td class="text-xs-center">
              {{ props.item.day }}
            </td>
            <td
              v-for="plan in dynamicPlans"
              :key="plan"
              class="text-xs-center"
            >
              {{ props.item[plan] || 0 }}
            </td>

            <td class="text-xs-right primary">
              {{ props.item.total }}
            </td>
          </tr>
        </template>
        <template #expand="props">
          <v-sheet color="grey">
            <v-container>
              <v-layout row>
                <v-flex x12>
                  <v-data-table
                    :headers="detailActivationHeaders"
                    :items="props.item.items"
                    item-key="dealer"
                    class="elevation-1"
                  >
                    <template #items="dealerProps">
                      <tr>
                        <td class="text-xs-left">
                          {{ dealerProps.item.dealer }}
                        </td>
                        <td
                          v-for="plan in dynamicPlans"
                          :key="plan"
                          class="text-xs-center"
                        >
                          {{ dealerProps.item[plan] || 0 }}
                        </td>

                        <td class="text-xs-center primary">
                          {{ dealerProps.item.total }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-sheet>
        </template>
        <template #footer>
          <tr>
            <td class="text-xs-right">
              Sub-total:
            </td>
            <td
              v-for="plan in dynamicPlans"
              :key="plan"
              class="text-xs-center primary--text"
            >
              {{ totals[plan] }}
            </td>

            <td class="text-xs-right primary">
              {{ totalActivation }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-subheader>Reloads</v-subheader>
      <v-sheet>
        <v-btn
          absolute
          dark
          fab
          small
          top
          right
          color="light-green"
          @click="exportTracking(reloads)"
        >
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-sheet>
      <v-data-table
        :headers="reloadHeaders"
        :items="reloads"
        :expand="expand"
        :loading="loading"
        item-key="day"
        class="elevation-1"
      >
        <template #items="props">
          <tr
            :active="props.selected"
            @click="props.expanded = !props.expanded"
          >
            <td class="text-xs-center">
              {{ props.item.day }}
            </td>
            <td class="text-xs-center primary">
              {{ props.item.total }}
            </td>
          </tr>
        </template>
        <template #expand="props">
          <v-sheet color="grey">
            <v-container>
              <v-layout row>
                <v-flex x12>
                  <v-data-table
                    :headers="detailReloadHeaders"
                    :items="props.item.items"
                    item-key="dealer"
                    class="elevation-1"
                  >
                    <template #items="dealerProps">
                      <tr>
                        <td class="text-xs-left">
                          {{ dealerProps.item.dealer }}
                        </td>
                        <td class="text-xs-center primary">
                          {{ dealerProps.item.reload }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-sheet>
        </template>
        <template #footer>
          <tr>
            <td class="text-xs-right">
              Total:
            </td>
            <td class="text-xs-center primary">
              {{ Number(totalReload).toFixed(2) }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-subheader>Recruitments</v-subheader>
      <v-sheet>
        <v-btn
          absolute
          dark
          fab
          small
          top
          right
          color="light-green"
          @click="exportTracking(recruitments)"
        >
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-sheet>
      <v-data-table
        :headers="recruitmentHeaders"
        :items="recruitments"
        :expand="expand"
        :loading="loading"
        item-key="day"
        class="elevation-1"
      >
        <template #items="props">
          <tr
            :active="props.selected"
            @click="props.expanded = !props.expanded"
          >
            <td class="text-xs-center">
              {{ props.item.day }}
            </td>
            <td class="text-xs-center primary">
              {{ props.item.total }}
            </td>
          </tr>
        </template>
        <template #expand="props">
          <v-sheet color="grey">
            <v-container>
              <v-layout row>
                <v-flex x12>
                  <v-data-table
                    :headers="detailRecruitmentHeaders"
                    :items="props.item.items"
                    item-key="dealer"
                    class="elevation-1"
                  >
                    <template #items="dealerProps">
                      <tr>
                        <td class="text-xs-left">
                          {{ dealerProps.item.dealer }}
                        </td>
                        <td class="text-xs-center primary">
                          {{ dealerProps.item.recruitment }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-sheet>
        </template>
        <template #footer>
          <tr>
            <td class="text-xs-right">
              Total:
            </td>
            <td class="text-xs-center primary">
              {{ totalRecruitment }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </wide-panel>
  </v-scale-transition>
</template>

<script>
import { DateTime } from 'luxon'
import { createGetParams } from '@/rest'
import security from '@/security'
import * as XLSX from 'xlsx'

export default {
  components: {
    WidePanel: () => import(/* webpackChunkName: "widePanel" */ '@/components/WidePanel'),
  },
  data () {
    return {
      month: DateTime.local().setZone('Asia/Kuala_Lumpur').toFormat('yyyy-LL'),
      today: DateTime.local().setZone('Asia/Kuala_Lumpur').toFormat('yyyy-LL-dd'),
      thisMonth: DateTime.local().setZone('Asia/Kuala_Lumpur').toFormat('yyyy-LL'),
      expand: false,
      monthMenu: false,
      loading: false,
      title: 'Tracking',
      location: null,
      locations: [],
      activations: [],
      detailActivationHeaders: [],
      reloads: [],
      recruitments: [],
      activationHeaders: [],
      dynamicPlans: [],
      totals: {},
      reloadHeaders: [
        {
          text: 'Day',
          align: 'center',
          sortable: true,
          value: 'day',
        },
        {
          text: 'Total',
          align: 'center',
          sortable: true,
          value: 'total',
        },
      ],
      detailReloadHeaders: [
        {
          text: 'Dealer',
          align: 'left',
          sortable: true,
          value: 'dealer',
        },
        {
          text: 'Reload',
          align: 'center',
          sortable: true,
          value: 'reload',
        },
      ],
      recruitmentHeaders: [
        {
          text: 'Day',
          align: 'center',
          sortable: true,
          value: 'day',
        },
        {
          text: 'Total',
          align: 'center',
          sortable: true,
          value: 'total',
        },
      ],
      detailRecruitmentHeaders: [
        {
          text: 'Dealer',
          align: 'left',
          sortable: true,
          value: 'dealer',
        },
        {
          text: 'Recruitment',
          align: 'center',
          sortable: true,
          value: 'recruitment',
        },
      ],
      prepaid: 0,
      b10: 0,
      b39: 0,
      b49: 0,
      b39plus20: 0,
      b39plus50: 0,
      b59e: 0,
      b59db: 0,
      b89db: 0,
      b54db: 0,
      nu: 0,
      b150: 0,
      b39_fc: 0,
      tbg50: 0,
      b54db_fc: 0,
      b59db_fc: 0,
      b89db_fc: 0,
      b150_fc: 0,
      onefmain: 0,
      onefsub: 0,
      mysiswa35: 0,
      totalActivation: 0,
      totalReload: 0,
      totalRecruitment: 0,
    }
  },
  created: function () {
    !this.xforceAdmin && this.getXForceTracking(this.thisMonth)
    this.xforceAdmin && this.getXForceLocations()
  },
  computed: {
    xforceAdmin () {
      const properties = security.me.getProperties()
      let admin = false

      properties.forEach(property => {
        if (property.name === 'dashboard.xforce' && property.value === 'admin') {
          admin = true
        }
      })

      return admin
    },
  },
  watch: {
    location: function (location) {
      this.getXForceTracking(this.month, location.code)
    },
    month: function (month) {
      this.getXForceTracking(month)
    },
  },
  methods: {
    getXForceTracking: async function (month, code) {
      const params = code ? createGetParams({ month, code }) : createGetParams({ month })
      this.loading = true
      this.resetTotals()
      try {
        const response = await this.$rest.get('getXForceTracking.php', params)
        const activations = response.data.activations

        if (activations.length > 0) {
          const sample = activations[0]

          this.dynamicPlans = Object.keys(sample).filter(key =>
            !['day', 'items', 'total'].includes(key),
          )

          this.activationHeaders = [
            { text: 'Day', align: 'center', value: 'day' },
            ...this.dynamicPlans.map(plan => ({
              text: plan,
              align: 'center',
              value: plan,
            })),
            { text: 'Total', align: 'right', value: 'total' },
          ]
          this.detailActivationHeaders = [
            {
              text: 'Dealer',
              align: 'left',
              value: 'dealer',
            },
            ...this.dynamicPlans.map(plan => ({
              text: plan,
              align: 'center',
              value: plan,
            })),
            {
              text: 'Total',
              align: 'center',
              value: 'total',
            },
          ]
        }

        this.totals = {}
        this.totalActivation = 0

        activations.forEach(activation => {
          this.dynamicPlans.forEach(plan => {
            this.totals[plan] =
      Number(this.totals[plan] || 0) +
      Number(activation[plan] || 0)
          })

          this.totalActivation += Number(activation.total || 0)
        })

        // this.activations = activations
        response.data.reloads.forEach(reload => {
          this.totalReload += reload.total * 1
        })
        response.data.recruitments.forEach(recruitment => {
          this.totalRecruitment += recruitment.total
        })
        this.activations = response.data.activations
        this.reloads = response.data.reloads
        this.recruitments = response.data.recruitments
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    resetTotals: function () {
      this.activations = this.reloads = this.recruitments = []
      this.dynamicPlans = []
      this.totals = {}
      this.totalActivation = 0
      this.totalActivation = this.totalReload = this.totalRecruitment = 0
    },
    getXForceLocations: async function () {
      const params = createGetParams({ list: true })
      try {
        const response = await this.$rest.get('getXForceLocations.php', params)
        this.locations = response.data
      } catch (error) {
        console.log(error)
      }
    },
    exportTracking: function (object) {
      const month = DateTime.fromFormat(this.month, 'yyyy-LL').toFormat('LLL')
      const dealerId = this.xforceAdmin && this.location ? this.location.leadDealer : security.me.dealerId()
      const dayColumn = 0
      const data = []
      const merges = []
      let index = 1

      object.forEach(obj => {
        const merge = {
          s: {
            r: index,
            c: dayColumn,
          },
          e: {
            r: index,
            c: dayColumn,
          },
        }
        let firstRow = true
        obj.items.forEach(item => {
          let row = Array(1)

          if (firstRow) {
            row[0] = obj.day
            firstRow = false
          } else {
            merge.e.r = index
          }
          row = row.concat([
            item.dealer,
            ...this.dynamicPlans.map(plan => item[plan] || 0),
            item.total,
          ])
          data.push(row)
          index++
        })
        merge.e.r > merge.s.r && merges.push(merge)
      })

      let filename
      if (object === this.activations) {
        filename = 'activations'
        data.unshift([month, 'Dealer', ...this.dynamicPlans, 'Total'])
      } else if (object === this.reloads) {
        filename = 'reloads'
        data.unshift([month, 'Dealer', 'Reload'])
      } else {
        filename = 'recruitments'
        data.unshift([month, 'Dealer', 'Recruitment'])
      }
      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()
      if (merges.length > 0) {
        ws['!merges'] = merges
      }
      XLSX.utils.book_append_sheet(wb, ws, dealerId)
      XLSX.writeFile(wb, 'xforce-' + this.month + '-' + dealerId + '-' + filename + '.xlsx')
    },
  },
}
</script>
